import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex h-3.5 w-3.5 items-center justify-center" }

import { MessageRecipientTypeEnum } from '@/enums/messages/MessageRecipientTypeEnum';
import { 
  Users, CheckCircle, XCircle, Clock, ArrowDown, Repeat, 
  ArrowUp, TrendingDown, Package, ShoppingCart, MessageSquare, 
  GitMerge,
  GitCommit
} from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageRecipientTypeBadge',
  props: {
    recipient: {}
  },
  setup(__props: any) {

const recipientIcons = {
  [MessageRecipientTypeEnum.ALL]: Users,
  [MessageRecipientTypeEnum.SUBSCRIBERS]: CheckCircle,
  [MessageRecipientTypeEnum.NON_SUBSCRIBERS]: XCircle,
  [MessageRecipientTypeEnum.INACTIVE_SUBSCRIBERS]: Clock,
  [MessageRecipientTypeEnum.DOWNSELL]: ArrowDown,
  [MessageRecipientTypeEnum.RECURRENT]: Repeat,
  [MessageRecipientTypeEnum.UPSELLERS]: ArrowUp,
  [MessageRecipientTypeEnum.DOWNSELLERS]: TrendingDown,
  [MessageRecipientTypeEnum.PACKAGES]: Package,
  [MessageRecipientTypeEnum.ABANDONED_PIX]: ShoppingCart,
  [MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL]: MessageSquare,
  [MessageRecipientTypeEnum.FLOW_NODE]: GitMerge,
  [MessageRecipientTypeEnum.FLOW_CURRENT_NODE]: GitCommit,
  
}

const recipientClasses = {
  [MessageRecipientTypeEnum.ALL]: 'bg-blue-500 text-blue-50 bg-blue-500/10',
  [MessageRecipientTypeEnum.SUBSCRIBERS]: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
  [MessageRecipientTypeEnum.NON_SUBSCRIBERS]: 'bg-zinc-500 text-zinc-50 bg-zinc-500/10',
  [MessageRecipientTypeEnum.INACTIVE_SUBSCRIBERS]: 'bg-yellow-500 text-yellow-50 bg-yellow-500/10',
  [MessageRecipientTypeEnum.DOWNSELL]: 'bg-orange-500 text-orange-50 bg-orange-500/10',
  [MessageRecipientTypeEnum.RECURRENT]: 'bg-purple-500 text-purple-50 bg-purple-500/10',
  [MessageRecipientTypeEnum.UPSELLERS]: 'bg-teal-500 text-teal-50 bg-teal-500/10',
  [MessageRecipientTypeEnum.DOWNSELLERS]: 'text-amber-50 bg-amber-500/10',
  [MessageRecipientTypeEnum.PACKAGES]: 'bg-indigo-500 text-indigo-50 bg-indigo-500/10',
  [MessageRecipientTypeEnum.ABANDONED_PIX]: 'bg-red-500 text-red-50 bg-red-500/10',
  [MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL]: 'bg-cyan-500/10 text-cyan-50 bg-cyan-500/10',
  [MessageRecipientTypeEnum.FLOW_NODE]: 'bg-sky-500/50 ring-sky-200 text-white', // Azul mais suave
  [MessageRecipientTypeEnum.FLOW_CURRENT_NODE]: 'bg-blue-500/50 text-white ring-blue-100',
}

const recipientLabels = {
  [MessageRecipientTypeEnum.ALL]: 'Todos',
  [MessageRecipientTypeEnum.SUBSCRIBERS]: 'Assinantes',
  [MessageRecipientTypeEnum.NON_SUBSCRIBERS]: 'Não Assinantes',
  [MessageRecipientTypeEnum.INACTIVE_SUBSCRIBERS]: 'Assinantes Inativos',
  [MessageRecipientTypeEnum.DOWNSELL]: 'Downsell',
  [MessageRecipientTypeEnum.RECURRENT]: 'Recorrentes',
  [MessageRecipientTypeEnum.UPSELLERS]: 'Upsellers',
  [MessageRecipientTypeEnum.DOWNSELLERS]: 'Downsellers',
  [MessageRecipientTypeEnum.PACKAGES]: 'Pacotes',
  [MessageRecipientTypeEnum.ABANDONED_PIX]: 'PIX Abandonado',
  [MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL]: 'Aprovação de Chat',
  [MessageRecipientTypeEnum.FLOW_NODE]: 'Leads que passaram pelo nó',
  [MessageRecipientTypeEnum.FLOW_CURRENT_NODE]: 'Leads que estão no nó',
}



return (_ctx: any,_cache: any) => {
  return (recipientClasses[_ctx.recipient])
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([
      'inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-medium',
      recipientClasses[_ctx.recipient],
    ])
      }, [
        _createElementVNode("span", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(recipientIcons[_ctx.recipient]), { class: "h-3 w-3" })),
          _createElementVNode("span", {
            class: _normalizeClass([[
          'relative inline-flex h-2 w-2 rounded-full',
          recipientClasses[_ctx.recipient].split(' ')[0],
        ], "hidden"])
          }, null, 2)
        ]),
        _createTextVNode(" " + _toDisplayString(recipientLabels[_ctx.recipient]), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})